export const SUPPORTED_FIELDS_ENHANCEMENT: string[] = [
    "text_field",
    "number_input",
    "multiline",
    "markdown",
    "email",
    "select",
    "multi_select",
];
